//This file is names _adc.js so it is first, otherwise the gulp concatination won't work correctly

var adc = new Object();